<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div *ngIf="giftCard" class="container-giftcards">
    <div class="header">
      <h1 class="title">{{'EDIT_CARD' | translate}}</h1>
      <app-back-arrow-settings [routerLink]="['/giftCardTypes']"></app-back-arrow-settings>
    </div>
    <form>
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <div class="form-card" *ngIf="!loading">
        <div class="form-group-container">
          <div>
            <label class="form-label" for="giftcard_name">{{'NAME' | translate}}</label>
            <input type="text" class="form-control" id="giftCardName" placeholder="{{'CARD_NAME' | translate}}"
              [(ngModel)]="giftCard.name" name="giftCardName" />
          </div>
          <div>
            <label class="form-label" for="giftCard_validityMonths">{{'VALIDITY_MONTHS' | translate}}</label>
            <select class="form-control" id="giftCardValidMonths"
              [(ngModel)]="giftCard.validMonths" name="giftCardValidMonths">
              <option value="0">{{'NO_EXPIRATION' | translate}}</option>
              <option *ngFor="let month of monthsArray" [value]="month">{{ month }}</option>
            </select>
          </div>
          <div>
            <label class="form-label" for="giftCard_stock">{{'QUANTITY' | translate}}</label>
            <select class="form-control" id="giftCardStock"
              [(ngModel)]="giftCard.stock" name="giftCardStock">
              <option value="999999">{{'UNLIMITED' | translate}}</option>
              <option *ngFor="let quantity of quantityArray" [value]="quantity">{{ quantity }}</option>
            </select>
          </div>
        </div>
        <div class="form-switch">
          <label class="form-label" for="giftCard_status">{{'STATUS' | translate}}</label>
          <div class="switch-title-container">
            <label class="form-check-label switch" for="flexCheckDefault">
              <input class="form-check-input" type="checkbox" id="flexCheckDefault" 
                [checked]="giftCard.status === 1"
                (change)="onStatusChange($event)" />
              <span class="slider round"></span>
              <div class="switch-text">
                <span>{{ giftCard.status === 1 ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}</span>
              </div>
            </label>
          </div>
        </div>
        <div class="images-container">
          <div class="img-label">{{'IMAGES' | translate}}:</div>
          <div cdkDropList cdkDropListOrientation="horizontal" class="image-list">
            <div class="image-box" cdkDragDisabled>
              <button class="add-img" (click)="triggerFileInput()">+</button>
              <input id="btn-upload" type="file" class="d-none" (change)="onFileSelected($event)">
            </div>
            <div class="image-box" *ngIf="showExistingImage && giftCard.images && giftCardImage.length === 0" cdkDrag>
              <img [src]="sanitizeImageURL(giftCard.images)" alt="Current Image">
              <button type="button" class="btn btn-danger delete-button" (click)="deleteImage(giftCard.images)">
                x
              </button>
            </div>
            <div class="image-box" *ngFor="let image of giftCardImage" cdkDrag>
              <img [src]="sanitizeImageURL(image.imageURL)" alt="New Image">
              <button type="button" class="btn btn-danger delete-button" (click)="deleteImage(image)">
                x
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="switch-container">
            <div class="input-container">
              <label class="form-label" for="giftCard_amount">{{'AMOUNTS' | translate}}</label>
              <button type="button" class="btn btn-outline-secondary small-btn confirm-btn text-white" (click)="addAmount()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
              </button>
            </div>
            <div class="value-container" *ngFor="let amount of amounts; let i = index">
              <input type="number" min="0" class="form-control" 
                [(ngModel)]="amounts[i]" [name]="'amount_' + i"
                placeholder="{{'AMOUNT' | translate}} {{ i + 1 }}"/>
              <div class="delete-btn-container">
                <button type="button" class="btn btn-outline-secondary delVariantBtn small-btn cancel-btn" 
                  (click)="removeAmount(i)" [disabled]="amounts.length === 1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <button type="button" class="btn btn-outline-secondary submit-btn" (click)="validateFormData()">
            {{'SAVE' | translate}}
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="modal giftcard-confirm-modal fade" id="successGiftCardsModal" tabindex="-1">
    <div class="modal-dialog giftcard-modal-dialog" role="document">
      <div class="modal-content giftcard-modal-content">
        <div class="modal-body giftcard-modal-body">
          <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
          <p class="text-center">{{'CARD_SAVED_SUCCESSFULLY' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal giftcard-confirm-modal fade" id="errorGiftCardsModal" tabindex="-1">
    <div class="modal-dialog giftcard-modal-dialog" role="document">
      <div class="modal-content giftcard-modal-content">
        <div class="modal-body giftcard-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>